var _rect, _rect2, _path, _path2, _path3, _rect3, _circle, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileverification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 170,
    viewBox: "0 0 350 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 170,
    rx: 40,
    fill: "#E3E9F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 330,
    height: 150,
    rx: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 60L300 60",
    stroke: "#E3E9F2",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170 85L300 85",
    stroke: "#E3E9F2",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 110L240 110",
    stroke: "#E3E9F2",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 110,
    height: 110,
    rx: 16.9231,
    fill: "#E3E9F2",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 133,
    r: 15,
    fill: "#19B3B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.015 138.713L141.333 129.973L139.681 128.237L133.015 135.242L129.652 131.709L128 133.444L133.015 138.713Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7320_1806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 53.5V58H112.5V71.5C112.5 73.8869 111.552 76.1761 109.864 77.864C108.176 79.5518 105.887 80.5 103.5 80.5C101.113 80.5 98.8239 79.5518 97.1361 77.864C95.4482 76.1761 94.5 73.8869 94.5 71.5V58H99V53.5H90V71.5C90.0055 74.6873 91.1377 77.7701 93.1963 80.2035C95.255 82.6368 98.1076 84.264 101.25 84.7975V98.5C101.25 102.08 99.8277 105.514 97.296 108.046C94.7642 110.578 91.3304 112 87.75 112C84.1696 112 80.7358 110.578 78.2041 108.046C75.6723 105.514 74.25 102.08 74.25 98.5V84.6803C76.371 84.1326 78.2194 82.8303 79.4489 81.0173C80.6783 79.2043 81.2043 77.0051 80.9283 74.832C80.6523 72.6589 79.5932 70.6611 77.9495 69.213C76.3059 67.765 74.1906 66.9661 72 66.9661C69.8095 66.9661 67.6941 67.765 66.0505 69.213C64.4069 70.6611 63.3478 72.6589 63.0718 74.832C62.7957 77.0051 63.3217 79.2043 64.5512 81.0173C65.7806 82.8303 67.629 84.1326 69.75 84.6803V98.5C69.75 103.274 71.6464 107.852 75.0221 111.228C78.3978 114.604 82.9761 116.5 87.75 116.5C92.5239 116.5 97.1023 114.604 100.478 111.228C103.854 107.852 105.75 103.274 105.75 98.5V84.7975C108.892 84.264 111.745 82.6368 113.804 80.2035C115.862 77.7701 116.995 74.6873 117 71.5V53.5H108ZM67.5 76C67.5 75.11 67.7639 74.24 68.2584 73.4999C68.7529 72.7599 69.4557 72.1831 70.2779 71.8425C71.1002 71.5019 72.005 71.4128 72.8779 71.5865C73.7508 71.7601 74.5527 72.1887 75.182 72.818C75.8113 73.4474 76.2399 74.2492 76.4136 75.1221C76.5872 75.995 76.4981 76.8998 76.1575 77.7221C75.8169 78.5443 75.2401 79.2471 74.5001 79.7416C73.7601 80.2361 72.89 80.5 72 80.5C70.807 80.4986 69.6632 80.0241 68.8196 79.1805C67.9759 78.3368 67.5014 77.1931 67.5 76Z",
    fill: "#8799AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7320_1806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(49 49)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileverification);
export default __webpack_public_path__ + "static/media/profileverification.3e782e7a9d326aa53698012f8cb19c8b.svg";
export { ForwardRef as ReactComponent };